import React from "react";
import SignUp from "../components/SignUp/SignUp";

const SignupPage = () => {

  return (
  
    <SignUp/>
  );
};

export default SignupPage; 